import { render, staticRenderFns } from "./GameHistory.vue?vue&type=template&id=c72b5c8c&"
import script from "./GameHistory.vue?vue&type=script&lang=js&"
export * from "./GameHistory.vue?vue&type=script&lang=js&"
import style0 from "./GameHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports